import React from 'react'
import AddNewUser from './AddNewUser'
import AddNewOperation from './AddNewOperation'
import AddNewAppointment from './AddNewAppointment'
import AddNewAptFromFile from './AddNewAppointment/AddNewAptFromFile'
import AddNewPatient from './AddNewPatient'
import DeletePopup from './DeletePopup'
import AttachmentsHandling from './AttachmentsHandling'
import AddNewExpense from './AddNewExpense'
import AddNewWithdraw from './AddNewWithdraw'
import ShowPayingsPtList from './ShowPayingsPtList'
import FastServices from './FastServices'
import ViewChanges from './ViewChanges'
import DeleteServiceConfirmation from './DeleteServiceConfirmation'
import { deleteOperation } from '../../../../Redux/operations/operationsSlice'
import { useDispatch } from 'react-redux'
import { deleteAppointment } from '../../../../Redux/appointments/appointmentSlice'
import { deletePatient } from '../../../../Redux/patients/patientsSlice'
import { deleteUser } from '../../../../Redux/users/usersSlice'
import ViewCashierHistory from './ViewCashierHistory'

const index = ({ pointer, data, close }) => {
  const dispatch = useDispatch()
  switch (pointer) {
    case 1: {
      return !data?.deleteData ? (
        <AddNewUser close={close} userdata={data} />
      ) : (
        <DeletePopup
          hint={'Delete this employee: ' + data?.displayName + ' ?'}
          fn={() =>
            dispatch(
              deleteUser({
                ...data,
                close
              })
            )
          }
          close={close}
        />
      )
    }
    case 2: {
      return !data?.deleteData ? (
        <AddNewOperation close={close} data={data} />
      ) : (
        <DeletePopup
          hint={'Delete this operation: ' + data?.op_name + ' ?'}
          fn={() =>
            dispatch(
              deleteOperation({
                ...data,
                close
              })
            )
          }
          close={close}
        />
      )
    }
    case 3: {
      return !data?.deleteData ? (
        <AddNewAppointment close={close} data={data} />
      ) : (
        <DeletePopup
          hint={'Remove this appointment from calendar? (It will still be visible in the patient file)'}
          fn={() =>
            dispatch(
              deleteAppointment({
                ...data,
                keepInPatientRecord: true,
                close
              })
            )
          }
          close={close}
        />
      )
    }
    case 4: {
      return !data?.deleteData ? (
        <AddNewPatient close={close} userdata={data} />
      ) : (
        <DeletePopup
          hint={'Delete this Patient: ' + data?.full_name + ' ? All their appointments will also be deleted from the calendar.'}
          fn={() =>
            dispatch(
              deletePatient({
                ...data,
                close
              })
            )
          }
          close={close}
        />
      )
    }
    case 5: {
      return <AddNewAptFromFile close={close} data={data} />
    }
    case 6: {
      return <AttachmentsHandling close={close} data={data} />
    }
    case 7: {
      return <AddNewExpense close={close} data={data} />
    }
    case 8: {
      return <ShowPayingsPtList close={close} />
    }
    case 9: {
      return <AddNewWithdraw close={close} data={data} />
    }
    case 10: {
      return <FastServices close={close} data={data} />
    }
    case 11: {
      return <DeleteServiceConfirmation close={close} data={data} />
    }
    case 12: {
      return <ViewChanges close={close} data={data} />
    }
    case 13: {
      return <ViewCashierHistory close={close} data={data} />
    }
    default: {
      close()
      break
    }
  }
}

export default index
